module.exports = __webpack_public_path__ + "img/base_divers_by_night.e8b180e4.svg";